import { useEffect, useState } from "react";

const FALLBACK_LABELS = { apple: "App Store", gplay: "Google Play" };

export default function StoreSwitch({
  appId,
  section,
  stores = [],
  defaultStore = "",
  labels = {},
  ariaLabel = "Store",
}) {
  const key = `appcorpus.section-store.${appId}.${section}`;
  const [store, setStore] = useState(() => {
    try {
      const saved = sessionStorage.getItem(key);
      if (saved && stores.includes(saved)) return saved;
    } catch {
      // Private mode — stay on the SSR default.
    }
    return stores.includes(defaultStore) ? defaultStore : stores[0] || "";
  });

  useEffect(() => {
    if (!store) return;
    try {
      sessionStorage.setItem(key, store);
    } catch {
      // Persistence is optional.
    }
  }, [key, store]);

  if (stores.length < 2 || !store) return null;
  const name = `store-${section}`;

  return (
    <div className={`store-switch store-switch--${store}`}>
      <div className="store-switch__track" role="radiogroup" aria-label={ariaLabel}>
        <span className="store-switch__thumb" aria-hidden="true" />
        {stores.map((id) => (
          <span key={id} className="store-switch__option">
            <input
              className="store-switch__input"
              type="radio"
              name={name}
              id={`${name}-${id}`}
              value={id}
              checked={store === id}
              onChange={() => setStore(id)}
            />
            <label className="store-switch__label" htmlFor={`${name}-${id}`}>
              {labels[id] || FALLBACK_LABELS[id] || id}
            </label>
          </span>
        ))}
      </div>
    </div>
  );
}
